import React from "react";
import { Map, GoogleApiWrapper, InfoWindow, Marker } from "google-maps-react";

export const GoogleMap = GoogleApiWrapper({
  apiKey: "AIzaSyBdnn576U4MOi9XmdWVMo601hQUTK7h_kM",
})(({ google }) => {
  return (
    <div className="google-map" style={{ width: "100%", height: "400px" }}>
      <Map
        google={google}
        zoom={18}
        style={{
          width: "100%",
          height: "100%",
        }}
        initialCenter={{
          lat: 46.773956244717844,
          lng: 23.615999081994616,
        }}
      >
        <Marker name={"iDesign"}>
          <InfoWindow visible={true}>
            <div>
              <p>{"Light Detail"}</p>
            </div>
          </InfoWindow>
        </Marker>
      </Map>
    </div>
  );
});
